// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__1NGIo","Page":"Pagination_Page__1OIfB","Current":"Pagination_Current__22fUQ","Total":"Pagination_Total__1HmUI"};